import {WithAPI} from "../../../../api/temperature";
import {Dialog, DialogClose, DialogContent, DialogOptions} from "../../../generic/dialog";
import {Sensor} from "../../../../api/sensor";
import {useFetchAndRender} from "../../../fetchAndRender";
import {useState} from "preact/hooks";
import {useAlert} from "../../../generic/alert";
import {Card} from "../../../generic/card";
import {FormFooter, FormGroup} from "../../../generic/form";
import RangeSlider from "../../../generic/slider";
import DatePicker from "react-datepicker";
import {Button} from "../../../generic/button";
import {useTemperature} from "../../../generic/temperature";
import {useFlash} from "../../../generic/flash";

export function CapSensorDialog({api, sensor, ...props}: WithAPI & DialogOptions & { sensor: Sensor }) {
    const [data] = useFetchAndRender(async () => {
        return (await api.sensor.get({
            attributes: ["highest", "lowest"],
            filter: {
                active: undefined,
                ids: [sensor.id]
            }
        })).sensors[0];
    }, {interval: 0});

    if (!data) {
        return null;
    }

    const {
        format: formatTemperature,
        convert: convertTemperature,
        unit: temperatureUnit,
        toCelsius
    } = useTemperature();

    const min = convertTemperature(Math.floor(data.lowest?.value ?? 0));
    const max = convertTemperature(Math.ceil(data.highest?.value ?? 0));

    const [range, setRange] = useState<[number, number]>([min, max]);

    const {showConfirm} = useAlert();
    const {success} = useFlash();

    return <Dialog {...props}>
        <DialogContent>
            <Card title={`Trim sensor ${sensor.name} by value`}>
                <form onSubmit={(e) => {
                    e.preventDefault();

                    showConfirm(
                        "Trim sensor data?",
                        <>
                            <p>{`Do you really want to trim sensor data from ${formatTemperature(range[0], false)} to ${formatTemperature(range[1], false)}?`}</p>
                            <p class={"text-danger"}><b>This operation cannot be undone!</b></p>
                        </>
                    ).then((resolution) => {
                        if (resolution == "yes") {
                            api.sensor.cap(
                                sensor,
                                toCelsius(range[0]),
                                toCelsius(range[1])
                            ).then(() => {
                                success(`Sensor ${sensor.name} has been trimmed to range from ${formatTemperature(range[0], false)} to ${formatTemperature(range[1], false)}`);
                                props.onOpenChange(false);
                            })
                        }
                    });
                }}>
                    <FormGroup>
                        <label for="input--trim">Trim sensor data to range of values:</label>
                        <RangeSlider
                            min={min}
                            max={max}
                            value={range}
                            onInput={(value: [number, number]) => {
                                setRange(value);
                            }}
                        />
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <div style={{display: "flex", gap: ".2rem", alignItems: "center"}}>
                                <input
                                    type="number"
                                    min={min}
                                    max={range[1]}
                                    value={range[0]}
                                    onChange={(e) => {
                                        setRange([Number.parseInt(e.currentTarget.value), range[1]]);
                                    }}
                                /> {temperatureUnit}
                            </div>
                            <div style={{display: "flex", gap: ".2rem", alignItems: "center"}}>
                                <input
                                    type="number"
                                    min={range[0]}
                                    max={max}
                                    value={range[1]}
                                    onChange={(e) => {
                                        setRange([range[0], Number.parseInt(e.currentTarget.value)]);
                                    }}
                                /> {temperatureUnit}
                            </div>
                        </div>
                    </FormGroup>

                    <FormFooter>
                        <Button type="submit">Trim</Button>
                        <DialogClose>Cancel</DialogClose>
                    </FormFooter>
                </form>
            </Card>
        </DialogContent>
    </Dialog>
}
